import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

export const TileButtonsContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  gap: theme.spacing(1),
  padding: theme.spacing(1),
}));
